import { NgClass } from '@angular/common';
import { booleanAttribute, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BaseInput } from './../../models';
import { InputLabelComponent } from './../input-label/input-label.component';
import { InputTooltipComponent } from './../input-tooltip/input-tooltip.component';
import { AutocompleteInputComponent } from './../inputs/autocomplete-input/autocomplete-input.component';
import { CheckboxInputComponent } from './../inputs/checkbox-input/checkbox-input.component';
import { DateInputComponent } from './../inputs/date-input/date-input.component';
import { FileInputComponent } from './../inputs/file-input/file-input.component';
import { ListInputComponent } from './../inputs/list-input/list-input.component';
import { NopInputComponent } from './../inputs/nop-input/nop-input.component';
import { RadiosInputComponent } from './../inputs/radios-input/radios-input.component';
import { SelectInputComponent } from './../inputs/select-input/select-input.component';
import { TextareaInputComponent } from './../inputs/textarea-input/textarea.component';
import { TextboxInputComponent } from './../inputs/textbox-input/textbox-input.component';
import { ValidationInputMessagesComponent } from './../validation-input-messages/validation-input-message.component';

@Component({
	selector: 'app-form-input',
	templateUrl: './form-input.component.html',
	standalone: true,
	imports: [
		NgClass,
		InputLabelComponent,
		InputTooltipComponent,
		NopInputComponent,
		TextboxInputComponent,
		FileInputComponent,
		TextareaInputComponent,
		SelectInputComponent,
		AutocompleteInputComponent,
		CheckboxInputComponent,
		RadiosInputComponent,
		ListInputComponent,
		DateInputComponent,
		ValidationInputMessagesComponent
	]
})
export class FormInputComponent {
	@Input({ transform: booleanAttribute }) filter: boolean;
	@Input() form: UntypedFormGroup;
	/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
	@Input() field: BaseInput | any;
	/* eslint-enable @typescript-eslint/no-redundant-type-constituents */
	@Input() name: string;
}
